import BranchAPIs from '@/API/branch-api'

const widgetDefault = {
  reference: '',
  enabled: false,
  type: 'slide',
  direction: 'left',
  border_shape: 'rounded',
  border_thickness: '0',
  button_color: '#e00a0a',
  border_color: '#000000',
  font_size: 'medium',
  font_color: '#ffffff',
  text: 'See Menu and Order',
}
export default {
  namespaced: true,
  state: {
    menu: false,
    temp_widget: widgetDefault,
  },
  getters: {
    tempWidget: (state: any) => state.temp_widget,
    menuEnabled: (state: any) => state.menu,
    widgetEnabled: (state: any) => state.temp_widget?.enabled ?? false,
  },
  mutations: {
    SET_TEMP_Widget(state: any, payload: any) {
      state.temp_widget = payload
    },
    SET_Widget_TYPE(state: any, payload?: any) {
      state.temp_widget.type = payload
    },
    SET_WIDGET_ENABLED(state: any, payload?: any) {
      state.temp_widget.enabled = payload
    },
    SET_REFERENCE(state: any, payload: string) {
      state.temp_widget.reference = payload
    },
  },
  actions: {
    async FETCH_DEPENDENCIES(context: any) {
      const res = await BranchAPIs.getMenuWidget(context.rootGetters['branches/currentBranchId'])
      if (res?.menu_widget?.type) {
        await context.commit('SET_TEMP_Widget', res.menu_widget)
      }
      context.commit('SET_REFERENCE', context.rootGetters['branches/currentBranch']?.reference_id ?? '')
    },
    async UPDATE_WIDGET(context: any) {
      const widget = { ...context.state.temp_widget, enabled: 1 }
      // eslint-disable-next-line no-return-await
      return (await BranchAPIs.updateMenuWidget(context.rootGetters['branches/currentBranchId'], widget))
    },
  },
}
